/* eslint-disable */


/**
 * Create styles for `<Spinner />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<Spinner />` styles
 */
const spinnerStyles = ({ theme }) => ({
  loader: {
    height: `100%`,
    marginBottom: theme.spacing(1) * 2,
    marginTop: theme.spacing(1) * 2,
    width: `100%`,
  },
});

export default spinnerStyles;
